export function getDynamicItemSize(
  container: HTMLElement
): { width: number; height: number } {
  if (!container) return { width: 0, height: 0 };

  const dynamicAncestor = container.closest(
    ".dynamic-item"
  ) as HTMLElement | null;
  const parent = dynamicAncestor || container.parentElement;
  if (!parent) return { width: 0, height: 0 };

  let width = 0;
  let height = 0;

  if (dynamicAncestor) {
    const rect = dynamicAncestor.getBoundingClientRect();
    width = rect.width;
    height = rect.height;
    const styleWidth = dynamicAncestor.style.width?.trim();
    const styleHeight = dynamicAncestor.style.height?.trim();

    if (styleWidth.endsWith("px")) width = parseFloat(styleWidth);
    if (styleHeight.endsWith("px")) height = parseFloat(styleHeight);
  }
  if (width <= 0 || height <= 0) {
    parent.offsetHeight;
    const rect = parent.getBoundingClientRect();
    width = width || rect.width;
    height = height || rect.height;
  }
  width = Math.max(0, Math.round(width));
  height = Math.max(0, Math.round(height));

  return { width, height };
}
